module.exports = __webpack_public_path__ + "static/media/feedback-faq-non@2x.18b877dc.png";